import { render, staticRenderFns } from "./CommodityCounterparty.vue?vue&type=template&id=29548fd4&"
import script from "./CommodityCounterparty.vue?vue&type=script&lang=js&"
export * from "./CommodityCounterparty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports